export enum StrongAuthentOriginEnum {
  LOGIN = 'LOGIN',
  TEL_UPDATE = 'TEL_UPDATE',
  TEL_UPDATE_MAIL = 'TEL_UPDATE_MAIL',
  PASSWORD_UPDATE = 'PASSWORD_UPDATE',
  VOUCHER = 'VOUCHER',
  ACCOUNT_CREATION = 'ACCOUNT_CREATION'
}
